module.exports = __webpack_public_path__ + "static/img/ys.e193723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Virus/Adenovirus/ys.png
// module id = V101
// module chunks = 16